import $ from 'jquery';
window.$ = window.jQuery = $;

import {
	menuMobile,
	menuSearch,
	menuSticky
} from "./js/menu";
import {
	sliderTestimonial,
	sliderAlumni,
	sliderAuthor,
	sliderCertificationCourse,
	sliderTabs,
	sliderPartners,
	sliderImgTxt,
	sliderPriceTable
} from "./js/slider";
import {
	backToTop,
	heightCourseBox,
	khTxtExpand,
	faqAccordion,
	colsListHover,
	statsToHero,
	filterMobile
} from "./js/ui";
import {
	frontpage_cert_arges,
	ubermagic,
	disablescrollonburgerclick,
	ubermagicclick,
	moveme,
	handlemoveme
} from "./js/detect-responsive";


(($) => {
    $(() => {
		// header
		menuMobile()
		menuSearch()
		menuSticky()

		// sliders
		sliderTestimonial()
		sliderAlumni()
		sliderAuthor()
		sliderCertificationCourse()
		sliderTabs()
		sliderPartners()
		sliderImgTxt()
		sliderPriceTable()
		
		// ui
		backToTop()
		heightCourseBox()
		khTxtExpand()
		faqAccordion()
		colsListHover()
		statsToHero()
		filterMobile()

		// responsive
		frontpage_cert_arges()
		ubermagic()
		disablescrollonburgerclick()
		ubermagicclick()
		// moveme()
		// handlemoveme()
	})
})(jQuery)